module.exports = vendors_tr_b4d27732d63d3a1b1aef;